// 日历
import { activityApi2, exercisePath, videoApi2 } from '@/public/utils/basePath';
import { cryptoInstance } from '@/public/fetch/index';
// 获取日历 推荐的 omo 共学营和国际大师课
export const getCalendarRecommendCourse = (albumId) => {
    return cryptoInstance.get(`${activityApi2}/calendar365/index/${albumId}`);
};
// 获取日历 推荐的 omo 共学营和国际大师课
export const getCourse = (data, params) => {
    return cryptoInstance.get(`${videoApi2}/v5/recommend/${data.moduleType}/${data.userId}/${data.typeId}`, { params });
};
// 获取推荐的病例练习
export const getCalendarRecommendExam = (params) => {
    return cryptoInstance.get(`${exercisePath}/exercise/exercise/recommend`, {
        params
    });
};
// 收藏
export const getCalendarBookmark = (data) => {
    return cryptoInstance.get(`${activityApi2}/calendar/bookmark/${data.type}/${data.userId}/${data.calendarId}`);
};
// 日历列表
export const getCalendarList = (departmentId, params) => {
    return cryptoInstance.get(`${activityApi2}/calendar/knowledge/list/${departmentId}`, {
        params
    });
};
// 收藏列表
export const getBookmarkList = (userId, data) => {
    return cryptoInstance.get(`${activityApi2}/calendar/bookmark/list/${userId}`, {
        params: data
    });
};
// 日历详情
export const getDetail = (calendarId, params) => {
    return cryptoInstance.get(`${activityApi2}/calendar/knowledge/detail/${calendarId}`, {
        params
    });
};
